import { render, staticRenderFns } from "./IpWhitelistBlockedMessage.vue?vue&type=template&id=60c57de6&scoped=true"
import script from "./IpWhitelistBlockedMessage.vue?vue&type=script&lang=js"
export * from "./IpWhitelistBlockedMessage.vue?vue&type=script&lang=js"
import style0 from "./IpWhitelistBlockedMessage.vue?vue&type=style&index=0&id=60c57de6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c57de6",
  null
  
)

export default component.exports